module.exports = __webpack_public_path__ + "img/foto20.01463a9a.jpg";